import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { Report1 } from './Report1'
import { Report2 } from './Report2'
import { Report3 } from './Report3'
import { Report4 } from './Report4'
import { Report5_AccessLog } from './Report5_AccessLog'

const ReportRoute: React.FC = () => {
    return (
        <>
            <Switch>
                <Route path='/report/report1'>
                    <PageTitle breadcrumbs={[]}>รายงานปริมาณการใช้งาน</PageTitle>
                    <Report1 />
                </Route>
                <Route path='/report/report2'>
                    <PageTitle breadcrumbs={[]}>รายงานการใช้งาน</PageTitle>
                    <Report2 />
                </Route>
                <Route path='/report/report3'>
                    <PageTitle breadcrumbs={[]}>รายงานสถิติคำถาม / คำตอบ</PageTitle>
                    <Report3 />
                </Route>
                <Route path='/report/report4'>
                    <PageTitle breadcrumbs={[]}>รายงาน False Message</PageTitle>
                    <Report4 />
                </Route>
                <Route path='/report/report5'>
                    <PageTitle breadcrumbs={[]}>รายงานการเข้าใช้งาน</PageTitle>
                    <Report5_AccessLog />
                </Route>
                <Redirect from='/report' exact={true} to='/report/users' />
            </Switch>
        </>
    )
}

export default ReportRoute
